import React, { useState, useEffect } from "react";
import _ from "lodash";
import axios from "axios";
import moment from "moment";
import {
  makeStyles,
  IconButton,
  InputAdornment,
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  TablePagination,
  Checkbox,
  Box,
  Backdrop,
  CircularProgress,
} from "@material-ui/core";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import Card from "../../components/Card/Card";
import CardHeader from "../../components/Card/CardHeader";
import CardBody from "../../components/Card/CardBody";
import CustomInput from "../../components/CustomInput/CustomInput";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import People from "@material-ui/icons/People";
import OfferMastersView from "./OfferMastersView";
import OfferMastersAdd from "./OfferMastersAdd";
import OfferMastersEdit from "./OfferMastersEdit";
import { DeleteOffersAPI, GetAllOffersAPI } from "../../config/api";
import { ConfirmationDialog } from "../../components/common";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ImportExcel } from "../Master/ImportExcel";
import { CloudDownload, CloudUpload } from "@material-ui/icons";
import * as XLSX from 'xlsx';
import Tooltip from "@material-ui/core/Tooltip";
const useStyles = makeStyles((theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
}));

const columns = [
  { id: "offerName", label: "Offer Name" },
  {
    id: "rate",
    label: "Product Amount",
    format: (value) =>
      Number(value).toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      }),
  },
  {
    id: "offerAmount",
    label: "Offer Amount",
    format: (value) =>
      Number(value).toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      }),
  },
  { id: "readyMasterRangeId", label: "Product" },
  { id: "action", label: "Action" },
];
export default function OfferMastersList(props) {
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openViewDialog, setOpenViewDialog] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(null);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [offers, setOffers] = useState([]);
  const [openImportDialog, setOpenImportDialog] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  let userInfo = useSelector((state) => state.userReducer.userInfo);
  let authToken = useSelector((state) => state.userReducer.authToken);

  useEffect(() => {
    range();
  }, []);

  function range() {
    let x = -8;
    let y = -2;
    let array = [];
    let xMax = null,
      yMax = null;
    if (x < 0) {
      xMax = -1 * x * 100;
    }

    if (y < 0) {
      yMax = -1 * y * 4 + 1;
    }

    let incrY = 0;

    for (let indexY = 0; indexY <= yMax; indexY++) {
      for (let index = 25; index <= xMax; index += 25) {
        if (index < 100 && incrY == 0) {
          array.push({ x: "-0" + index, y: "000" });
        } else if (index < 100 && incrY < 100) {
          array.push({ x: "-0" + index, y: "-0" + incrY });
        } else if (index >= 100 && incrY == 0) {
          array.push({ x: "-" + index.toString(), y: "000" });
        } else if (index >= 100 && incrY < 100) {
          array.push({ x: "-" + index.toString(), y: "-0" + incrY });
        } else {
          array.push({ x: "-" + index.toString(), y: "-" + incrY.toString() });
        }
      }
      incrY += 25;
    }
  }

  useEffect(() => {
    _getOffers();
  }, [openAddDialog, openEditDialog]);

  async function _getOffers() {
    try {
      let res = await axios.get(GetAllOffersAPI(userInfo.entity), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setOffers(res.data.offersMaster);
    } catch (err) {
      // console.log(err);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   });
    }
  }

  async function _deleteItem(item) {
    try {
      // Server now performs soft delete + side-effects behind this DELETE route
      await axios.delete(DeleteOffersAPI(item._id), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      toast.success("Successfully Deleted!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      _getOffers();
      // window.location.reload();
    } catch (e) {
      // console.log("err:", e);
      // toast.error(("Something went wrong, Please Contact Admin") , {
      //   position: "top-center",
      //   autoClose: 1500,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      //   theme: "light",
      //   });
    }
  }

  const handleOpenConfirmationModal = (object) => {
    setOpenConfirmationModal(object);
  };

  const handleCloseConfirmationModal = () => {
    setOpenConfirmationModal(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function closeViewDialog() {
    setOpenViewDialog(null);
  }

  function closeAddDialog() {
    setOpenAddDialog(null);
  }

  function closeEditDialog() {
    setOpenEditDialog(null);
  }

  let data = offers;

  // Export function
  const handleExport = async () => {
    setIsExporting(true);
    const loadingToastId = toast.loading('🔄 Preparing export... Please wait', {
      position: "top-center",
      autoClose: false,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: "colored",
    });

    try {
      // First, get the total count
      toast.update(loadingToastId, {
        render: '📊 Fetching total record count...',
        type: 'info',
        isLoading: true,
      });

      const totalRes = await axios.get(GetAllOffersAPI(userInfo.entity) + `&limit=1&skip=0`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      const total = totalRes.data.total || (totalRes.data.offersMaster?.length || 0);
      
      if (total === 0) {
        toast.update(loadingToastId, {
          render: '❌ No data to export!',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
        setIsExporting(false);
        return;
      }

      // Fetch all data using the total count
      toast.update(loadingToastId, {
        render: `📥 Downloading ${total} records... This may take a moment`,
        type: 'info',
        isLoading: true,
      });

      const res = await axios.get(GetAllOffersAPI(userInfo.entity) + `&limit=${total}&skip=0`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      const allData = res.data.offersMaster || [];
      if (!allData || allData.length === 0) {
        toast.update(loadingToastId, {
          render: '❌ No data to export!',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        });
        setIsExporting(false);
        return;
      }

      toast.update(loadingToastId, {
        render: '⚙️ Processing data for export...',
        type: 'info',
        isLoading: true,
      });

      const exportHeadings = [
        { id: "offerName", label: "Offer Name" },
        { id: "rate", label: "Product Amount" },
        { id: "offerAmount", label: "Offer Amount" },
        { id: "readyMasterRangeId", label: "Product" }
      ];

      const exportData = allData.map(row => {
        const rowData = {};
        exportHeadings.forEach(col => {
          let value = row[col.id];
          if (col.id === 'readyMasterRangeId' && value && value.productName) {
            value = value.productName;
          }
          if (col.id === 'rate' && row.readyMasterRangeId && row.readyMasterRangeId.rate) {
            value = row.readyMasterRangeId.rate;
          }
          rowData[col.id] = value;
        });
        return rowData;
      });

      toast.update(loadingToastId, {
        render: '💾 Generating Excel file...',
        type: 'info',
        isLoading: true,
      });

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Offers');
      XLSX.writeFile(workbook, 'offers_export.xlsx');

      toast.update(loadingToastId, {
        render: `✅ Successfully exported ${allData.length} records to Excel!`,
        type: 'success',
        isLoading: false,
        autoClose: 4000,
        style: {
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '14px',
        },
      });
    } catch (error) {
      console.error('Export error:', error);
      toast.update(loadingToastId, {
        render: `❌ Export failed: ${error.response?.data?.message || error.message || 'Unknown error'}`,
        type: 'error',
        isLoading: false,
        autoClose: 5000,
        style: {
          background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
          color: '#fff',
          fontWeight: 'bold',
          fontSize: '14px',
        },
      });
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h4 className={classes.cardTitleWhite}>Offers</h4>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                }}
              >
                <CustomInput
                  id="search"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    style: {
                      marginTop: 0,
                      marginRight: 10,
                      color: "white",
                    },
                    placeholder: "Search",
                    value: searchTerm,
                    onChange: (e) => setSearchTerm(e.target.value),
                    endAdornment: (
                      <InputAdornment position="end">
                        <People />
                      </InputAdornment>
                    ),
                  }}
                />
                <Tooltip title={"Export to excel"}>
                  <IconButton
                    color={"primary"}
                    onClick={handleExport}
                    disabled={isExporting}
                    style={{ color: "white" }}
                  >
                    <CloudDownload />
                  </IconButton>
                </Tooltip>
                <Tooltip title={"Import Excel to database"}>
                  <IconButton
                    color={"primary"}
                    onClick={() => setOpenImportDialog(true)}
                    style={{ color: "white" }}
                  >
                    <CloudUpload />
                  </IconButton>
                </Tooltip>
                <IconButton
                  aria-label="add"
                  style={{ color: "white" }}
                  onClick={() => setOpenAddDialog(true)}
                >
                  <AddIcon />
                </IconButton>
              </div>
            </div>
          </CardHeader>

          <CardBody>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <Checkbox
                    style={{
                      color: "#512da8",
                    }}
                    onChange={(e) => {
                      let c = [];
                      if (e.target.checked) {
                        data.map((i) => {
                          c.push(i._id);
                        });
                      }
                      setSelectedRows(c);
                    }}
                    checked={
                      selectedRows.length > 0 &&
                      data.length === selectedRows.length
                    }
                    inputProps={{ "aria-labelledby": -1 }}
                  />
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={"center"}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    return (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.code}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            style={{
                              color: "#512da8",
                            }}
                            onChange={() => {
                              let copy = _.clone(selectedRows);
                              if (_.includes(copy, row._id)) {
                                let index = _.indexOf(copy, row._id);
                                copy.splice(index, 1);
                              } else {
                                copy.push(row._id);
                              }
                              setSelectedRows(copy);
                            }}
                            checked={_.includes(selectedRows, row._id)}
                            inputProps={{ "aria-labelledby": row._id }}
                          />
                        </TableCell>
                        {columns.map((column) => {
                          const value = row[column.id];

                          if (column.id === "action") {
                            return (
                              <TableCell align={"center"}>
                                <Box display={"flex"} justifyContent={"center"}>
                                  {/* <IconButton
                                    aria-label="edit"
                                    onClick={() =>
                                      setOpenEditDialog({
                                        open: true,
                                        item: row,
                                      })
                                    }
                                  >
                                    <EditIcon />
                                  </IconButton> */}
                                  <IconButton
                                    onClick={() =>
                                      handleOpenConfirmationModal({
                                        title: "Delete Record",
                                        msg: "Do you want to delete this record?",
                                        onPress: () => _deleteItem(row),
                                      })
                                    }
                                    aria-label="delete"
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Box>
                              </TableCell>
                            );
                          }

                          if (column.id === "readyMasterRangeId") {
                            return (
                              <TableCell key={column.id} align={"center"}>
                                {value?.productName}
                              </TableCell>
                            );
                          }

                          if (column.id === "rate") {
                            return (
                              <TableCell key={column.id} align={"center"}>
                                {Number(
                                  row.readyMasterRangeId?.rate
                                ).toLocaleString("en-IN", {
                                  maximumFractionDigits: 2,
                                  style: "currency",
                                  currency: "INR",
                                })}
                              </TableCell>
                            );
                          }
                          return (
                            <TableCell key={column.id} align={"center"}>
                              {column.format ? column.format(value) : value}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </CardBody>
        </Card>
      </GridItem>
      {openViewDialog ? (
        <OfferMastersView
          open={openViewDialog.open}
          close={closeViewDialog}
          item={openViewDialog.item}
        />
      ) : null}
      {openAddDialog ? (
        <OfferMastersAdd open={openAddDialog} close={closeAddDialog} />
      ) : null}

      {openEditDialog ? (
        <OfferMastersEdit
          open={openEditDialog}
          close={closeEditDialog}
          item={openEditDialog.item}
        />
      ) : null}

      {openConfirmationModal ? (
        <ConfirmationDialog
          open={openConfirmationModal}
          onClose={handleCloseConfirmationModal}
          onConfirm={openConfirmationModal.onPress}
          title={"Delete Record"}
          msg={"Do you want to delete this record?"}
        />
      ) : null}
      <ImportExcel
        db={"offersMasters"}
        open={openImportDialog}
        close={() => {
          setOpenImportDialog(false);
          _getOffers();
        }}
      />
      <Backdrop
        open={isExporting}
        style={{
          zIndex: 9999,
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress size={60} thickness={4} style={{ color: '#512da8', marginBottom: 20 }} />
          <Box style={{ fontSize: '18px', fontWeight: 'bold', marginTop: 10 }}>
            Exporting Data...
          </Box>
          <Box style={{ fontSize: '14px', marginTop: 5, opacity: 0.8 }}>
            Please wait while we prepare your Excel file
          </Box>
        </Box>
      </Backdrop>
    </GridContainer>
  );
}
